import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  getDocuments,
  sieteDiasSend,
  sieteDiasRecep,
} from "../../redux/actions/actionDocument";
import { getClientes } from "../../redux/actions/actionClient";
import DocumentsCard from "./documentsCard";
import FilterSeven from "./filterSeven";
import FilterSaldo from "./filterSaldo";
import { format, addDays } from "date-fns";
import {
  SALDADO,
  NO_SALDADO,
  ALL_DOCUMENTS,
  SIETE_SEND,
  SIETE_OUT,
  SIETE_ALL,
} from "../../Constantes/constantesFiltros";

export default function Documents() {
  let dateAux = format(new Date(), "yyyy/MM/dd");

  const dispatch = useDispatch();
  let documents = useSelector((state) => state.documents.allDocuments);
  const clients = useSelector((state) => state.clientes.allClientes);
  const [docAux, setDocAux] = useState();
  const [activo, setActivo] = useState(false);
  const [checkSal, setCheckSal] = useState({selectedOption: ALL_DOCUMENTS});
  const [checkNoSal, setCheckNoSal] = useState(false);
  const [docs, setDocs] = useState();
  const [docFind, setDocFind] = useState();

  let documentsAux = structuredClone(documents[0]);
  
  useEffect(() => {
    dispatch(getDocuments());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getClientes());
  }, [dispatch]);

  console.log(documents);
  

  // const handleCheckSaldado = (e) => {
  //   const { value } = e.target;
  //   console.log(value);
  //   setCheckSal(!checkSal)
  //   if(!checkSal){      
  //     if(docAux === undefined){
  //       let auxDocuments = documents[0].filter((e) => e.state === true);
  //       setDocAux(auxDocuments);
  //     }
  //     if(docAux !== undefined){
  //       let auxDocuments = docAux.filter((e) => e.state === true);
  //       setDocAux(auxDocuments);
  //     }
  //   } else if(checkSal){
  //     setDocAux(documents[0])      
  //   }
        
  // };

  // const handleCheckNoSaldado = (e) => {
  //   const { value } = e.target;
  //   console.log(value);
  //   setCheckNoSal(!checkNoSal);
  //   if(!checkNoSal){
  //     if(docAux === undefined){
  //       let auxDocuments = documents[0].filter((e) => e.state === false);
  //       setDocAux(auxDocuments);
  //     }
  //     if(docAux !== undefined){
  //       let auxDocuments = docAux.filter((e) => e.state === false);
  //       setDocAux(auxDocuments);
  //     }
  //   } else if(checkNoSal){
  //     setDocAux(documents[0]);
  //   }   
  // };

  const handleCheck = (e) => {
    const {value} = e.target 
    console.log(value)
    
    setCheckSal({selectedOption: e.target.value})
    switch (value) {
      case SALDADO: {
        if(docAux === undefined){
          let auxDocuments = documents[0].filter((e) => e.state === true);
          setDocAux(auxDocuments);
        }
        if(docAux !== undefined){
          let auxDocuments = documents[0].filter((e) => e.state === true);
          setDocAux(auxDocuments);
        }

      }        
      break;
      case NO_SALDADO: {
        if(docAux === undefined){
          let auxDocuments = documents[0].filter((e) => e.state === false);
          setDocAux(auxDocuments);
        }
        if(docAux !== undefined){
          let auxDocuments = documents[0].filter((e) => e.state === false);
          setDocAux(auxDocuments);
        }
      }
      break;
      case ALL_DOCUMENTS: {
        setDocAux(documents[0])
      }
      break;
      case SIETE_SEND: {
        let today = new Date()
        let dateSeven = addDays(today, 7)
        let dateMenosDosDias = addDays(today, -2)
        console.log(dateMenosDosDias);
        let send = documents[0].filter((e) =>
            new Date(e.dateSend) >= dateMenosDosDias && new Date(e.dateSend) <= dateSeven                                  
          )        
        setDocAux(send)
      }
      break;
      case SIETE_OUT: {
        let today = new Date()
        let dateSeven = addDays(today, 7)
        let dateMenosDosDias = addDays(today, -4)
        let send = documents[0].filter((e) =>
          new Date(e.dateReception) >= dateMenosDosDias && new Date(e.dateReception) <= dateSeven                                  
        )        
      setDocAux(send)
    }
    break;

      default:
        break;
    }
    
  }

  const handleSelect = (e) => {
    //console.log(e.target.value)
    const { value } = e.target;
    console.log(value);
    switch(value) {
        case SIETE_SEND: {
        let today = new Date()
        let dateSeven = addDays(today, 7)
        let send = documents[0].filter((e) =>
            new Date(e.dateSend) >= today && new Date(e.dateSend) <= dateSeven                                  
          )        
        setDocAux(send)
        break;
        }
        case SIETE_OUT: {
          let today = new Date()
          let dateSeven = addDays(today, 7)
          let send = documents[0].filter((e) =>
            new Date(e.dateReception) >= today && new Date(e.dateReception) <= dateSeven                                  
          )        
        setDocAux(send)
        break;
        }
        case ALL_DOCUMENTS: {           
        setDocAux(documents[0])
        break;
        }
      }
  };

  const handleChange = (e) =>{
    const { value } = e.target;
    console.log(value)
    setDocs(value)   
    filterDoc(value)  
    console.log(docFind)   
  }

  const filterDoc = (doc) => {
    if(docAux === undefined){
    let result = documents[0].filter( (e) => {
        if(e.client_id.name.toString().toLowerCase().includes(doc.toLowerCase())
          || e.numberDocument == doc
        ){
            //console.log(e)
           return e 
        }
    })
    setDocAux(result)
  } else {
    let result = docAux.filter( (e) => {
      if(e.client_id.name.toString().toLowerCase().includes(doc.toLowerCase())
        || e.numberDocument == doc
      ){
          //console.log(e)
         return e 
      }
  })
  setDocAux(result)
  }
}

  console.log(documentsAux);
  console.log(docAux);
  console.log(activo);
  console.log(documents);

  return (
    <div className="container m-5 border-black border-2">
      <div></div>
      <div>
        <div>
          <p className="text-xl pb-8 underline">Remitos - Informes</p>
        </div>
        <div className="flex flex-row h-20 bg-cyan-700 border-2 border-black">
          
        <div className="flex flex-col w-40 text-[12px] font-bold bg-slate-200">
            <label>A Siete Dias</label>
            <div>
              <div className="flex flex-row w-40">
                <div className="w-36">Envios</div>
              <input
                className=""
                type="radio"
                name="envios"
                checked={checkSal.selectedOption === SIETE_SEND}
                value={SIETE_SEND}     
                onChange={handleCheck}           
              />
              </div>
              <div className="flex flex-row w-40">
                <div className="w-36">Recepciones</div>
              <input
                className=""
                type="radio"
                name="recepciones"
                checked={checkSal.selectedOption === SIETE_OUT}
                value={SIETE_OUT}
                onChange={handleCheck}
              />
              </div>              
            </div>
          </div>

          <div className="flex flex-col w-44 text-[12px] font-bold bg-slate-200 pl-2">
            <label>Estados</label>
            <div>
              <div className="flex flex-row w-40">
                <div className="w-36">Todos los Documentos</div>
              <input
                className=""
                type="radio"
                name="saldos"
                checked={checkSal.selectedOption === ALL_DOCUMENTS}
                value={ALL_DOCUMENTS}     
                onChange={handleCheck}           
              />
              </div>
              <div className="flex flex-row w-40">
                <div className="w-36">Saldados</div>
              <input
                className=""
                type="radio"
                name="saldos"
                checked={checkSal.selectedOption === SALDADO}
                value={SALDADO}
                onChange={handleCheck}
              />
              </div>
              <div className="flex flex-row w-40">
                <div className="w-36">No Saldados</div>
              <input
                type="radio"
                name="saldos"
                checked={checkSal.selectedOption === NO_SALDADO}
                value={NO_SALDADO}
                onChange={handleCheck}
              />
              </div>
            </div>
          </div>
          <div className="flex flex-row text-[12px] w-56 font-bold bg-slate-200 pt-1 pl-1">
                <p className="mr-2">Buscar</p>
                <input
                    className="border border-slate-700 rounded w-44 h-4 text-center" 
                    type="text"
                    placeholder="Nombre Cliente"
                    onChange={handleChange}
                    //value={docs}
                />
            </div>
        </div>
        <div className="flex flex-row">
          <div className="text-[14px] font-bold text-center w-12">Doc N°</div>
          <div className="text-[14px] font-bold text-left pl-2 w-60">
            Cliente
          </div>
          <div className="text-[14px] font-bold text-left pl-2 w-80">
            Domicilio Evento
          </div>
          <div className="text-[14px] font-bold text-center w-20">
            Fecha de Salida
          </div>
          <div className="text-[14px] font-bold text-center w-20">
            Fecha de Entrada
          </div>
          <div className="text-[14px] font-bold text-center w-20">Estado</div>
          <div className="text-[14px] font-bold text-center w-12">Armado</div>
          <div className="text-[14px] font-bold text-center w-12 pl-2">
            Entrega
          </div>
        </div>
          {docAux !== undefined ? (
            docAux.map(e => {
             return (
             <div key={e._id}>            
                  <DocumentsCard
                    key={e._id}
                    id={e._id}
                    addressEvent={e.addressEvent}
                    name_client={e.client_id.name}
                    dateReception={e.dateReception}
                    dateSend={e.dateSend}
                    numberDocument={e.numberDocument}
                    state={e.state}
                    armado={e.armado}
                    entregado={e.entregado}
                    parcial={e.parcial}
                  />              
          </div>
        
             )}) 
             
          ) : (
            documents[0] && documents[0].map(e => {
              return (
              <div key={e._id}>            
                   <DocumentsCard
                     key={e._id}
                     id={e._id}
                     addressEvent={e.addressEvent}
                     name_client={e.client_id.name}
                     dateReception={e.dateReception}
                     dateSend={e.dateSend}
                     numberDocument={e.numberDocument}
                     state={e.state}
                     armado={e.armado}
                     entregado={e.entregado}
                     parcial={e.parcial}
                   />              
           </div>
          )}))}
             
        
      </div>
    </div>
  );
}

